// src\Component\context\appContext.js
import React from 'react'

const AppContext = React.createContext({
    metaData: null,
    role: null,      // ✅ Add role in context
    setRole: () => {}  // ✅ Optional: add setter for convenience
});

export default AppContext
